import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {ModalAtualizacaoAppPage} from './modal-atualizacao-app.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
  ],
  declarations: [ModalAtualizacaoAppPage]
})
export class ModalAtualizacaoAppPageModule {
}
